export const experimentsInitialState = {
  isReady: false,
  isDisabled: false,
};

export default (state = experimentsInitialState, { type, value } = {}) => {
  switch (type) {
    case 'SET_EXPERIMENTS_READY':
      return {
        ...state,
        isReady: Boolean(value),
      };
    case 'SET_EXPERIMENTS_DISABLED':
      return {
        ...state,
        isDisabled: Boolean(value),
      };
    default:
      return state;
  }
};
